import { createSelector } from 'reselect';

const rawAuthorizeSelector = (state) => state.oauthAuthorize || {};

export const oauthAuthorizeStatusSelector = createSelector(
  rawAuthorizeSelector,
  (authorize) => authorize.status
);

export const claimsSelector = createSelector(
  oauthAuthorizeStatusSelector,
  (authorizeStatus) => {
    const claims = authorizeStatus?.data?.claims || [];
    return claims.map((claim) => claim.scope);
  }
);

export const cancelUriSelector = createSelector(
  oauthAuthorizeStatusSelector,
  (authorizeStatus) => {
    const redirectUri = authorizeStatus?.data?.redirectUri || '/';
    const state = authorizeStatus?.data?.state || '';
    const queryDelimiter = redirectUri?.includes('?') ? '&' : '?';
    return `${redirectUri}${queryDelimiter}error=access-denied&state=${state}`;
  }
);
